import { useEffect, useState } from 'react';

/**
 * Check meta tag for viewer showcases release, if
 * <meta name="viewer-showcases" content="1" /> exists in head, isViewerShowcases will be true
 * TODO: remove this hook after Viewer Showcase fully rollout
 */
export const useViewerShowcasesRelease = () => {
  const [isViewerShowcases, setIsViewerShowcases] = useState<boolean | null>(null);

  useEffect(() => {
    const releaseMetaTag = document.querySelector('meta[name="viewer-showcases"]');

    if (releaseMetaTag?.getAttribute('content') === '1') {
      setIsViewerShowcases(true);
    } else {
      setIsViewerShowcases(false);
    }
  }, []);

  return { isViewerShowcases };
};
